/**
 * Zone centroids for the map picker's default view when a business has no
 * pin yet. Copied VERBATIM from the source of truth:
 * apps/demo/lib/location/zones.ts `ZONE_CENTROIDS`. Do not hand-edit; if the
 * upstream values change, re-copy them here.
 */
export const ZONE_CENTROIDS: Record<string, readonly [number, number]> = {
  'Casco Viejo': [8.953, -79.5364],
  'San Francisco': [8.9936, -79.504],
  Obarrio: [8.9862, -79.5205],
  'Costa del Este': [9.0103, -79.4661],
  'El Cangrejo': [8.985, -79.528],
  'Bella Vista': [8.9793, -79.527],
  'Punta Pacífica': [8.9745, -79.503],
  Marbella: [8.98, -79.518],
  'Río Abajo': [9.008, -79.49],
  'Punta Paitilla': [8.97, -79.514],
  Clayton: [8.999, -79.586],
  Amador: [8.927, -79.532],
  Albrook: [8.985, -79.572],
  'Nuevo Tocumen': [9.102, -79.353],
  // Caracas (Dale Venezuela), same values as the demo's ZONE_CENTROIDS.
  Altamira: [10.4963, -66.8487],
  Chacao: [10.4915, -66.856],
  'Las Mercedes': [10.481, -66.86],
  'Los Palos Grandes': [10.499, -66.843],
  'La Castellana': [10.499, -66.853],
  'El Rosal': [10.489, -66.862],
  'Los Dos Caminos': [10.495, -66.83],
  'Sabana Grande': [10.494, -66.878],
  'El Hatillo': [10.425, -66.825],
  'La Candelaria': [10.504, -66.902],
  'Bello Monte': [10.487, -66.876],
  'Santa Fe': [10.464, -66.865],
};
